import './monthly-productivity.less';
import './table.less';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { reduxForm, Form, FieldArray, Field } from 'redux-form';
import InputField from '../../shared/form-elements/input';
import SelectField from '../../shared/form-elements/select/field';
import { formatYearMonth } from '../../shared/format';

class MonthlyProductivity extends Component {
	componentDidMount() {
		this.props.fetchMonthlyProductivity(this.props.params.id);
	}

	render() {
		const { intl, updateMonthlyProductivity, handleSubmit } = this.props;
		return (
			<div className="table-container table-container--projector admin-list-table">
				<div className="table-container--projector__body">
					<Form
						className="table-container--projector__body-content"
						onSubmit={handleSubmit(data => updateMonthlyProductivity(data, this.props.params.id))}
					>
						<table className="simple-table simple-table--static productivity-plan">
							<thead className="simple-table__head font-roboto-medium">
								<tr>
									<th>{intl('Year-Month (i.e. 2022-07)')}</th>
									<th>{intl('Country')}</th>
									<th>{intl('CRM Approves Plan')}</th>
									<th>{intl('Desired profit usd')}</th>
									<th>{intl('Affiliates plan')}</th>
									<th>{intl('Actions')}</th>
								</tr>
							</thead>

							<FieldArray name="monthlyProductivity" component={RenderFieldArray} {...this.props} />
						</table>
					</Form>
				</div>
			</div>
		);
	}
}

MonthlyProductivity.propTypes = {
	intl: PropTypes.func
};

const RenderFieldArray = props => (
	<tbody className="simple-table__body">
		{props.fields.map((parentName, index) => {
			return (
				<tr key={index}>
					<td className="productivity-col">
						<Field
							name={`${parentName}.start`}
							component={InputField}
							normalize={formatYearMonth}
							showLabel={false}
							type="text"
						/>
					</td>
					<td className="productivity-col">
						<div className="ui-form__element">
							<Field
								name={`${parentName}.country_id`}
								searchable={true}
								showLabel={false}
								clearable={true}
								multi={false}
								countryCode={true}
								options={props.loadCountriesOptions}
								component={SelectField}
							/>
						</div>
					</td>
					<td className="productivity-col">
						<Field
							name={`${parentName}.desired_real_approves_count`}
							showLabel={false}
							component={InputField}
							type="number"
						/>
					</td>
					<td className="productivity-col">
						<Field
							name={`${parentName}.desired_profit_usd`}
							showLabel={false}
							component={InputField}
							type="number"
						/>
					</td>
					<td className="productivity-col">
						<Field
							name={`${parentName}.affiliates_plan`}
							showLabel={false}
							component={InputField}
							type="number"
						/>
					</td>
					<td className="productivity-col actions flex-center">
						<span
							className="action_delete position-relative top-20"
							onClick={() => props.fields.remove(index)}
						/>
					</td>
				</tr>
			);
		})}
		<div className="margin-top-15">
			<button
				className="ui-btn ui-btn-secondary margin-0-15"
				type="button"
				onClick={() => props.fields.push({})}
			>
				Add
			</button>
			<button className="ui-btn ui-btn-primary margin-0-15" type="submit"> Apply </button>
		</div>
	</tbody>
);

export default reduxForm({ form: 'monthlyProductivityForm', enableReinitialize: true })(MonthlyProductivity);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/admins/components/monthly-productivity.js